import styles from "./FormSelect.module.scss";
import cn from "classnames";
import { ReactComponent as IconArrow } from "../../../assets/icons/arrow-down.svg";
import { ReactComponent as IconCheck } from "../../../assets/icons/select.svg";
import Select, { OptionTypeBase } from "react-select";
import FormInputError from "../FormInputError/FormInputError";
import { useImperativeScrollOnSearch } from "../../../functions/useImperativeScrollOnSearch";
import { customSelectStyles, IFormSelect } from "./FormSelect";

const FormSelectWithScrollOnSearch = (props: IFormSelect) => {
  const {
    name,
    field,
    form,
    options,
    customSingleValue,
    dark,
    placeholder,
    setActiveIndex,
    defaultValue,
    value,
    isControls,
    handleChange,
    separator,
    isSearchable = true,
    disabled,
  } = props;

  const { handleInputValueChange, optionRefs } =
    useImperativeScrollOnSearch(thisHandleChange);

  const customDropdownIndicator = () => {
    return <IconArrow className={styles.icon} />;
  };

  const customOption = (props: {
    isSelected?: boolean;
    data?: any;
    innerProps?: any;
    innerRef?: any;
  }) => {
    const { innerProps, innerRef } = props;
    return (
      <div
        ref={innerRef}
        {...innerProps}
        className={cn(styles.option, props.isSelected && styles["isSelected"])}
      >
        <span
          ref={(element) =>
            optionRefs.current.push({ element, data: props?.data })
          }
        >
          {props?.data?.label}
        </span>
        {props.isSelected && <IconCheck className={styles.check} />}
      </div>
    );
  };

  const defaultSingleValue = (options: { data: { label: string } }) => {
    return (
      <div className={styles.singleValue}>
        <span className={styles.singleValueLabel}>{options.data.label}</span>
      </div>
    );
  };

  function thisHandleChange(e: OptionTypeBase) {
    if (form) {
      form.setFieldValue(field.name, e);
    }
    if (setActiveIndex) {
      setActiveIndex(e.value);
    }
    if (handleChange) {
      handleChange(e);
    }
  }

  return (
    <div className={cn(styles.wrapper, "mb-medium")}>
      <Select
        name={field ? field.name : name && name}
        options={options}
        isSearchable={isSearchable}
        components={{
          SingleValue: customSingleValue
            ? customSingleValue
            : defaultSingleValue,
          DropdownIndicator: customDropdownIndicator,
          IndicatorSeparator: () => null,
          Option: customOption,
        }}
        defaultValue={defaultValue ? defaultValue : field?.value && field.value}
        className={cn(
          styles.element,
          dark && styles["isDark"],
          isControls && styles["isControls"],
          separator && styles["hasSeparator"],
          disabled && styles["isDisabled"]
        )}
        onChange={(e) => thisHandleChange(e)}
        value={value ? value : field?.value && field.value}
        inputValue={""}
        onInputChange={handleInputValueChange}
        placeholder={placeholder ? placeholder : "Choose.."}
        styles={customSelectStyles}
        isDisabled={disabled}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: "rgba(139, 139, 139, 0.7)",
          },
        })}
      />
      {form && form.touched[field.name] && form.errors[field.name] && (
        <FormInputError errors={form.errors} inputName={field.name} />
      )}
    </div>
  );
};
export default FormSelectWithScrollOnSearch;
